import { FORMAT_TIME } from '@/utils'

export default FORMAT_TIME
